import React from 'react'
import Box from '@mui/material/Box'
import { ReactComponent as EffectsIcon } from 'assets/icons/effects.svg'

export const IconSpacer = () => (
  <Box mr={3} style={{ opacity: 0 }}>
    <EffectsIcon />
  </Box>
)
